import { PositionBreakPriceLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/PositionBreakPriceLine';
import { PositionBreakPriceTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/exits/PositionBreakPriceTacticPanel';
import { AddPositionBreakPriceTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddPositionBreakPriceTacticPanel';
import { PositionBreakPriceWrapper } from '../../../../components/displays/tradeplans/softOrderModules/exitTacticModules/PostitionBreakPriceModule/PositionBreakPriceWrapper';
import { PositionBreakPriceModule } from '../../../../components/forms/tradeplans/tradingPlanFormComponents/FieldComponents/exitTactics/modules/PositionBreakPriceModule';
import { PositionBreakPriceData } from './positionBreakPriceData';
import { validatePositionBreakPrice } from './validatePositionBreakPrice';

export const PositionBreakPrice = {
  //data class
  dataStore: PositionBreakPriceData,

  //string constants
  name: 'POSITION_BREAK_PRICE',
  tacticLabel: 'Position Break Price',
  addTacticLabel: 'Add Position Break Price',
  category: 'Exit',

  // components
  tradePlanFormModule: PositionBreakPriceModule,
  tacticPanel: PositionBreakPriceTacticPanel,
  addTacticPanel: AddPositionBreakPriceTacticPanel,
  wrapper: PositionBreakPriceWrapper,
  chartSoftOrderComponent: PositionBreakPriceLine,
  documentation: null,
  alertDetailsComponent: null,

  //functions
  setupDetailParser: null,
  validationFunction: validatePositionBreakPrice,
};
